@if (form) {
  <form
    [formGroup]="form"
    [boFormOptions]="options"
    (ngSubmit)="onSubmit()">
    @if (isRecurring()) {
      <app-select-topup-frequency
        (frequencyChange)="handleFrequencyChange($event)"
        [initialValue]="selectedRule()?.frequency"></app-select-topup-frequency>
    } @else {
      <p class="form-label">What is the start and end date for this target balance?</p>
      @if (!topupRuleId() || isStatusPending()) {
        <div class="form-group">
          <app-date-range-picker
            setMinMaxDateFor="TopupRules"
            [fromDate]="dateFrom()"
            [toDate]="dateTo()"
            (toDateChange)="setToDate($event)"
            (fromDateChange)="setFromDate($event)"></app-date-range-picker>
          <div class="create-rule-custom-spending-fields d-none">
            <app-form-field
              boFieldPath="date_start"
              [readonly]="true"></app-form-field>
          </div>
          <div class="d-none">
            <app-form-field
              boFieldPath="date_end"
              [hideLabel]="true"
              [readonly]="true"></app-form-field>
          </div>
        </div>
      }
      @if (isStatusActive()) {
        <div class="form-group">
          <label
            for="staticDateDisplay"
            class="d-none"
            >Start and end date</label
          >
          <input
            id="staticDateDisplay"
            class="form-control"
            type="text"
            disabled
            [value]="staticDateDisplay()" />
        </div>
      }
    }
    <p class="form-label">What is the target balance for the card?</p>
    <div class="currency-mask">
      <app-form-field
        boFieldPath="amount"
        [addCurrencyMask]="true"
        [currencyMaskOptions]="maskConfig"
        [inputClass]="hasCardLimitError() ? 'is-invalid' : ''"
        label="R0.00"
        [hideLabel]="true"></app-form-field>
    </div>
    @if (!isStatusCompleted()) {
      @if (isRecurring()) {
        <app-card-limit-display
          (hasCardLimitError)="handleCardLimitError($event)"
          [selectedFrequency]="selectedFrequency()"
          [amount]="form.get('amount')?.value"></app-card-limit-display>
      } @else {
        <div class="card border-secondary mb-4">
          <div class="card-body p-2">
            <p class="text-muted mb-0">Please note:</p>
            <ul class="text-muted ps-4 mb-0">
              @if (isStatusPending() || !topupRuleId()) {
                <li>
                  The target amount cannot be more than
                  {{ cardLimits()?.balance | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}.
                </li>
              }
              <li>
                Scheduled top-up rules take priority over recurring rules and will pause the recurring top-up rule while
                it is active.
              </li>
              @if (isStatusPending() || !topupRuleId()) {
                <li>Once a scheduled rule becomes active, it cannot be changed.</li>
              }
              @if (isStatusActive()) {
                <li>Once a scheduled rule becomes active, it cannot be changed.</li>
                <li>To extend this schedule, please create a new rule for the future dates.</li>
                <li>To end this rule, simply click the Stop button below when you want it to finish.</li>
                <li>
                  To move money on or off a card right away, use the
                  <button
                    class="btn-reset w-auto text-secondary btn-link"
                    (click)="goToImmediateTopup()">
                    immediate&nbsp;top-up
                  </button>
                  feature.
                </li>
              }
            </ul>
          </div>
        </div>
      }
    }
    <bo-non-field-errors />
    <div class="row gy-3 offcanvas-buttons">
      @if (topupRuleId() && !isStatusCompleted()) {
        <div
          class="col-12 col-sm-auto"
          [ngClass]="{ 'ms-sm-auto text-end': isDisabledScheduledRule() }">
          <button
            type="button"
            class="btn"
            [ngClass]="isDisabledScheduledRule() ? 'btn-primary' : 'btn-outline-dark'"
            (click)="onRemoveTopupRule()">
            {{ isStatusActive() ? 'Stop Rule' : 'Remove' }}
          </button>
        </div>
      }
      <div
        class="col-12 col-sm-auto ms-sm-auto"
        [ngClass]="{ 'd-none': isDisabledScheduledRule() }">
        <app-submit
          btnID="createEmployeeSubmitBtn"
          [icon]="false"
          [busy]="busy"
          [disabled]="
            form.invalid ||
            hasCardLimitError() ||
            !selectedFrequency() ||
            (!topupRuleId() && !selectedCard()) ||
            isDisabledScheduledRule()
          "
          [label]="topupRuleId() ? 'Update' : 'Add'"></app-submit>
      </div>
    </div>
  </form>
} @else {
  <app-loader
    class="my-4"
    [showError]="fetchError()"
    errorItem="topup rule">
  </app-loader>
}
